export const appRouteCatalog = [
  "/",
  "/about-us",
  "/betsy",
  "/contact-us",
  "/copyright",
  "/eco",
  "/faq",
  "/founders-note",
  "/gallery",
  "/get-naics",
  "/get-naics-rules",
  "/get-naics-rules-experimental",
  "/kcg",
  "/kcg-sandbox",
  "/login",
  "/login-utahdata",
  "/privacy-policy",
  "/profile",
  "/register",
  "/search",
  "/sitemap",
  "/sitemap1",
  "/sitemap2",
  "/sitemap-cards",
  "/sitemap-modern",
  "/sitemap-quick",
  "/sp",
  "/subscription-plans",
  "/support-sponsor-request",
  "/support-sponsor-request1",
  "/supporters-and-sponsors",
  "/uradd1",
  "/utah-at-a-glance",
  "/utah-at-a-glance/adventure-activities",
  "/utah-at-a-glance/air-quality-index",
  "/utah-at-a-glance/autism-dd",
  "/utah-at-a-glance/charging-stations",
  "/utah-at-a-glance/construction-intelligence",
  "/utah-at-a-glance/culture/festival",
  "/utah-at-a-glance/culture/history",
  "/utah-at-a-glance/culture/religious",
  "/utah-at-a-glance/demographics",
  "/utah-at-a-glance/draft",
  "/utah-at-a-glance/federal-agencies",
  "/utah-at-a-glance/federal-agencies/sba-advocacy",
  "/utah-at-a-glance/financial-institutions",
  "/utah-at-a-glance/hill-airforce-base",
  "/utah-at-a-glance/hospitals",
  "/utah-at-a-glance/in-demand-jobs-and-wages",
  "/utah-at-a-glance/mlm",
  "/utah-at-a-glance/places-to-visit",
  "/utah-at-a-glance/research-centers-and-institutes",
  "/utah-at-a-glance/sports-club",
  "/utah-at-a-glance/taxes",
  "/utah-at-a-glance/unemployment-rate",
  "/utah-at-a-glance/unemployment-rate/dataset",
  "/utah-at-a-glance/universities-and-schools",
  "/utah-at-a-glance/universities-and-schools/utah-schools",
  "/utah-at-a-glance/universities-and-schools/utah-schools/:districtSlug",
  "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
  "/utah-at-a-glance/universities-and-schools/utah-universities",
  "/utah-at-a-glance/utah-adventure-activities",
  "/utah-at-a-glance/utah-airports",
  "/utah-at-a-glance/utah-air-quality-index",
  "/utah-at-a-glance/utah-autism-dd",
  "/utah-at-a-glance/utah-budget",
  "/utah-at-a-glance/utah-charging-stations",
  "/utah-at-a-glance/utah-cities",
  "/utah-at-a-glance/utah-counties",
  "/utah-at-a-glance/utah-counties/utah-county",
  "/utah-at-a-glance/utah-demographics",
  "/utah-at-a-glance/utah-employment",
  "/utah-at-a-glance/utah-federal-agencies",
  "/utah-at-a-glance/utah-financial-institutions",
  "/utah-at-a-glance/utah-funfacts",
  "/utah-at-a-glance/utah-geothermal-hotspots",
  "/utah-at-a-glance/utah-governor",
  "/utah-at-a-glance/utah-hill-airforce-base",
  "/utah-at-a-glance/utah-history",
  "/utah-at-a-glance/utah-history/:year",
  "/utah-at-a-glance/utah-hospitals",
  "/utah-at-a-glance/utah-housing",
  "/utah-at-a-glance/high-voltage-transmission",
  "/utah-at-a-glance/utah-land",
  "/utah-at-a-glance/utah-legislature",
  "/utah-at-a-glance/utah-libraries",
  "/utah-at-a-glance/utah-mines",
  "/utah-at-a-glance/utah-mlm",
  "/utah-at-a-glance/utah-nonprofits",
  "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
  "/utah-at-a-glance/utah-operation-gigawatt",
  "/utah-at-a-glance/utah-places-to-visit",
  "/utah-at-a-glance/utah-places-to-visit/land-management-wilderness",
  "/utah-at-a-glance/utah-places-to-visit/national-forest-services",
  "/utah-at-a-glance/utah-places-to-visit/national-historic-site",
  "/utah-at-a-glance/utah-places-to-visit/national-monument",
  "/utah-at-a-glance/utah-places-to-visit/national-recreation-area",
  "/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges",
  "/utah-at-a-glance/utah-places-to-visit/national-forests",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/arches",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/bryce-canyon",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/zion",
  "/utah-at-a-glance/utah-places-to-visit/utah-stateparks",
  "/utah-at-a-glance/utah-research-centers-and-institutes",
  "/utah-at-a-glance/utah-sports-club",
  "/utah-at-a-glance/utah-state",
  "/utah-at-a-glance/utah-water-security-gauge",
  "/utah-at-a-glance/utah-taxes",
  "/utah-at-a-glance/utah-unemployment-rate",
  "/utah-at-a-glance/utah-universities-and-schools",
  "/utah-at-a-glance/utah-voters-count",
  "/utah-at-a-glance/whats-new",
  "/utah-at-a-glance/zipcodes",
  "/utah-at-a-glance/utah-zipcodes",
  "/verticals",
  "/verticals/aerospace-and-defense",
  "/verticals/construction",
  "/verticals/food-industry",
  "/verticals/hill-airforce-base-economic-impact",
  "/verticals/information",
  "/verticals/manufacturing",
  "/verticals/mining",
  "/verticals/professional-scientific-and-technical-services",
  "/verticals/transportation-and-warehousing",
  "/visitor-info",
  "/wip",
];

export const routeGroupOrder = [
  "home",
  "glance",
  "verticals",
  "tools",
  "site",
  "account",
  "sitemaps",
  "other",
];

export const routeGroupMeta = {
  home: {
    label: "Home",
    description: "Main landing page and entry point.",
    accent: "#155e75",
    soft: "#cffafe",
    glow: "rgba(8, 145, 178, 0.16)",
    rootPath: "/",
    nested: false,
  },
  glance: {
    label: "Utah At a Glance",
    description: "Statewide quick-access pages grouped in a clear menu structure.",
    accent: "#1d4ed8",
    soft: "#dbeafe",
    glow: "rgba(37, 99, 235, 0.16)",
    rootPath: "/utah-at-a-glance",
    nested: true,
  },
  verticals: {
    label: "Utah Verticals",
    description: "Industry and sector pages organized as nested menu links.",
    accent: "#0f766e",
    soft: "#ccfbf1",
    glow: "rgba(15, 118, 110, 0.16)",
    rootPath: "/verticals",
    nested: true,
  },
  tools: {
    label: "Tools & Programs",
    description: "Utility, AI, sandbox, search, and program pages.",
    accent: "#7c2d12",
    soft: "#ffedd5",
    glow: "rgba(234, 88, 12, 0.16)",
    nested: false,
  },
  site: {
    label: "Site Pages",
    description: "Public-facing informational, support, and general site pages.",
    accent: "#4338ca",
    soft: "#e0e7ff",
    glow: "rgba(79, 70, 229, 0.16)",
    nested: false,
  },
  account: {
    label: "Account",
    description: "Login, register, profile, and subscription pages.",
    accent: "#7e22ce",
    soft: "#f3e8ff",
    glow: "rgba(147, 51, 234, 0.16)",
    nested: false,
  },
  sitemaps: {
    label: "Sitemaps",
    description: "Existing sitemap experiences and alternate directory views.",
    accent: "#be123c",
    soft: "#ffe4e6",
    glow: "rgba(225, 29, 72, 0.16)",
    nested: false,
  },
  other: {
    label: "Other Pages",
    description: "Pages that do not fit the main public menu groups.",
    accent: "#475569",
    soft: "#e2e8f0",
    glow: "rgba(71, 85, 105, 0.16)",
    nested: false,
  },
};

const toolsPaths = new Set([
  "/betsy",
  "/eco",
  "/get-naics",
  "/get-naics-rules",
  "/get-naics-rules-experimental",
  "/kcg",
  "/kcg-sandbox",
  "/search",
  "/uradd1",
  "/wip",
]);

const sitePaths = new Set([
  "/about-us",
  "/contact-us",
  "/copyright",
  "/faq",
  "/founders-note",
  "/gallery",
  "/sp",
  "/support-sponsor-request",
  "/support-sponsor-request1",
  "/supporters-and-sponsors",
  "/visitor-info",
]);

const accountPaths = new Set([
  "/login",
  "/login-utahdata",
  "/privacy-policy",
  "/profile",
  "/register",
  "/subscription-plans",
]);

export const routeLabelOverrides = {
  "/": "Home",
  "/betsy": "Ask Betsy AI",
  "/eco": "Economic Impact",
  "/get-naics": "NAICS",
  "/get-naics-rules": "NAICS Rules",
  "/get-naics-rules-experimental": "NAICS Rules Experimental",
  "/kcg": "KCG",
  "/kcg-sandbox": "KCG Sandbox",
  "/login-utahdata": "Login UtahData",
  "/sitemap": "Sitemap",
  "/sitemap1": "Sitemap 1",
  "/sitemap2": "Sitemap 2",
  "/sitemap-cards": "Sitemap Cards",
  "/sitemap-modern": "Sitemap Modern",
  "/sitemap-quick": "Sitemap Quick",
  "/sp": "Business Card",
  "/uradd1": "URADD",
  "/utah-at-a-glance/autism-dd": "Autism and DD",
  "/utah-at-a-glance/mlm": "MLM",
  "/utah-at-a-glance/utah-autism-dd": "Utah Autism and DD",
  "/utah-at-a-glance/utah-mlm": "Utah MLM",
  "/utah-at-a-glance/utah-operation-gigawatt": "Utah Operation Gigawatt",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef":
    "Capitol Reef",
  "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland":
    "Canyonland",
  "/utah-at-a-glance/utah-voters-count": "Utah Voters Count",
  "/verticals/professional-scientific-and-technical-services":
    "Professional, Scientific and Technical Services",
};

const wordOverrides = {
  ai: "AI",
  dd: "DD",
  faq: "FAQ",
  kcg: "KCG",
  mlm: "MLM",
  naics: "NAICS",
  sba: "SBA",
  uradd: "URADD",
  wip: "WIP",
};

export const isDynamicRoute = (path) => path.includes("/:") || path.endsWith("/*");

export const formatSegmentLabel = (segment) => {
  if (!segment) {
    return "Page";
  }

  if (segment.startsWith(":")) {
    return `Dynamic ${segment.slice(1)}`;
  }

  return segment
    .split("-")
    .map((part) => {
      const lowerPart = part.toLowerCase();
      if (wordOverrides[lowerPart]) {
        return wordOverrides[lowerPart];
      }

      return lowerPart.charAt(0).toUpperCase() + lowerPart.slice(1);
    })
    .join(" ");
};

export const getRouteLabel = (path) => {
  if (routeLabelOverrides[path]) {
    return routeLabelOverrides[path];
  }

  if (path === "/") {
    return "Home";
  }

  const segments = path.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1];
  return formatSegmentLabel(lastSegment);
};

export const getRouteGroupKey = (path) => {
  if (path === "/") {
    return "home";
  }

  if (path.startsWith("/utah-at-a-glance")) {
    return "glance";
  }

  if (path.startsWith("/verticals")) {
    return "verticals";
  }

  if (path.startsWith("/sitemap")) {
    return "sitemaps";
  }

  if (accountPaths.has(path)) {
    return "account";
  }

  if (sitePaths.has(path)) {
    return "site";
  }

  if (toolsPaths.has(path)) {
    return "tools";
  }

  return "other";
};
